// @flow
import * as React from "react";

import { ConfigProvider, theme as antdTheme } from "antd";
import ENGLISH_GB_LOCALE from "antd/locale/en_GB";

import { useTheme } from "hooks/useTheme";

import "./lib/dayjs";

type Props = {
  children: React.Node,
};

function AntdConfigProvider({ children }: Props): React.Node {
  const { theme } = useTheme();

  const configTheme = React.useMemo(() => {
    return {
      algorithm: [theme === "dark" ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm, antdTheme.compactAlgorithm],
    };
  }, [theme]);

  return (
    <ConfigProvider locale={ENGLISH_GB_LOCALE} theme={configTheme}>
      {children}
    </ConfigProvider>
  );
}

export default AntdConfigProvider;
